import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=a9c4cfa8&scoped=true&lang=pug&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=a9c4cfa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c4cfa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})
